import { ChangeEvent, InputHTMLAttributes } from 'react';
import { Loading } from 'components';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  isLoading?: boolean;
}

export function DiscountInput({
  onChange,
  isLoading = false,
  value,
  ...rest
}: Props) {
  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    const { value } = event.target;

    const onlyNumberRegex = /\D/g;

    event.target.value = value.replace(onlyNumberRegex, '');

    if (value === '0' || value === '00') {
      event.target.value = '';
    } else if (value.length === 2 && value.charAt(0) === '0') {
      event.target.value = value.slice(1, 2);
    }

    if (value.length <= 2) {
      onChange && onChange(event);
    }
  }

  return (
    <div className="relative flex items-center text-font12">
      <input
        placeholder={isLoading ? '' : '0'}
        type="tel"
        className="min-h-10 w-14 min-w-14 rounded-lg border border-solid border-neutral-300
          bg-transparent pr-6 text-end text-font12 text-neutral-500 outline-none
          focus:border-neutral-500"
        readOnly={isLoading}
        onChange={handleChange}
        value={isLoading ? '' : value}
        {...rest}
      />

      {isLoading ? (
        <div
          className="pointer-events-none absolute flex w-full items-center justify-center
            text-neutral-500"
        >
          <Loading small />
        </div>
      ) : (
        <span className="pointer-events-none absolute right-3.5 text-neutral-500">
          %
        </span>
      )}
    </div>
  );
}
